import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    LaneFeeSelectorType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/ContractBasis/LaneFees.requests'

const useLoadLabelLaneFee = (id) => {
    return useRequest<LaneFeeSelectorType>({
        key: RequestKeys.getLaneFeeSelector,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.getLaneFee),
        enabled: Boolean(id),
    })
}

export default useLoadLabelLaneFee
